<template>
  <div>
    <ProcessValidationActivity
        :changes="changes"
        :activity="activity"
        v-if="activity.properties.relation.who_am_i === 'App\\Process\\Models\\Process'"
    />
    <SystemValidationActivity
        :changes="changes"
        :activity="activity"
        v-if="activity.properties.relation.who_am_i === 'App\\System\\Models\\System'"
    />
    <ActivityValidationActivity
        :changes="changes"
        :activity="activity"
        v-if="activity.properties.relation.who_am_i === 'App\\Activity\\Models\\Activity'"
    />
    <ThirdPartyValidationActivity
            :changes="changes"
            :activity="activity"
            v-if="activity.properties.relation.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"
    />

    <RiskScenarioValidationActivity
            :changes="changes"
            :activity="activity"
            v-if="activity.properties.relation.who_am_i === 'App\\RiskScenario\\Models\\RiskScenario'"
    />

    <GenericControlValidationActivity
            :changes="changes"
            :activity="activity"
            v-if="activity.properties.relation.who_am_i === 'App\\GenericControl\\Models\\GenericControl'"
    />

    <PolicyValidationActivity
            :changes="changes"
            :activity="activity"
            v-if="activity.properties.relation.who_am_i === 'App\\Maintenance\\Policy\\Models\\Policy'"
    />
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';

  import ProcessValidationActivity from '@/components/activity/process/ProcessValidation.vue';
  import SystemValidationActivity from '@/components/activity/system/SystemValidation.vue';
  import ActivityValidationActivity from '@/components/activity/activity/ActivityValidation.vue';
  import ThirdPartyValidationActivity from '@/components/activity/thirdparty/ThirdPartyValidation.vue';
  import RiskScenarioValidationActivity from '@/components/activity/risk/RiskScenarioValidation.vue';
  import GenericControlValidationActivity from '@/components/activity/genericcontrol/GenericControlValidation.vue';
  import PolicyValidationActivity from '@/components/activity/policy/PolicyValidation.vue';

  export default {
    name: 'ActivityValidation',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    props: {
      activity: {},
      changes: false
    },
    components: {
      UserLink,
      ProcessValidationActivity,
      SystemValidationActivity,
      ActivityValidationActivity,
      ThirdPartyValidationActivity,
      RiskScenarioValidationActivity,
      GenericControlValidationActivity,
      PolicyValidationActivity
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }

        }

        return words.join(' ');
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
